<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Пояснительная записка</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="filter-container" v-if="source === 'app6'">
            <div class="left-content">
               <span class="filter-title" style="margin-left: 15px">
                    {{ `${table_number} ${table_name6}
                    (код строки ${table_code} прогнозного консолидированного отчета о финансовом положении)` }}
                </span>
            </div>
            <div class="filter-actions ml-auto">
                <b-button v-if="pkfo1Tables.includes(table_number)" variant="light" @click="backToPkfo">
                    <i class="icon icon-keyboard icon-rotate-180"></i>
                    Назад к ПКФО-1
                </b-button>
                <b-button v-if="pkfo2Tables.includes(table_number)" variant="light" @click="backToPkfo">
                    <i class="icon icon-keyboard icon-rotate-180"></i>
                    Назад к ПКФО-2
                </b-button>
            </div>
        </div>
        <div class="table-container">
            <b-table
                :items="formApp"
                :fields="tableFields1_1"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="2" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template #cell(name_ru)="data">
                    <!-- строка-заголовок -->
                    <template v-if="!data.item.line_code">
                        <div
                            class="font-weight-bold text-center"
                            style="min-width: 1000px"
                        >
                            {{ data.item.name_ru }}
                        </div>
                    </template>
                    <!-- обычная строка -->
                    <template v-else>
                        <div class="text-left" style="width: 300px">
                            {{ data.value }}
                        </div>
                    </template>
                </template>
                <template #cell(line_code)="data">
                    <div v-if="data.item.line_code" class="text-center">
                        {{ data.value }}
                    </div>
                </template>
                <template #cell()="data">
                    <div
                        v-if="data.item.line_code && !(table_number === '2.1' &&
                        ['010', '013', '020', '023'].includes(data.item.line_code)) "
                        class="text-right">
                        <span
                            v-if="hasError(data.field.key, data.item.line_code)"
                            class="warning-icon"
                            :title="hasError(data.field.key, data.item.line_code).text"
                        >⚠</span>
                            {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                    </div>
                </template>
            </b-table>
            <!--  Строка примечаний   -->
            <table v-if="notes" class="table table-bordered text-center mt-0">
                <tbody>
                <tr>
                    <td colspan="6" class="text-left text-muted small">{{ notes }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import {Ax} from "@/utils";

export default {
    name: 'forecast-uo-note-tables',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        table_number: String,
        table_code: String,
        checkDataList: {
            type: Array,
            default: () => []
        },
        source: {
            type: String,
            default: null
        },
        table_name6: String
    },
    data() {
        return {
            loading: false,
            open: false,
            allOpen: false,
            table1_1: [],
            formApp: [],
            notes: null,
            currentView: 'pr6Inc',
            repdate: null,
            openRows: {},
            openCls: {},
            inputValues: [],
            totalRow: {
                fcat: 0,
                evaluation: 0,
                forecast_1: 0,
                forecast_2: 0,
                forecast_3: 0,
            },
            pkfo1Tables: Array.from(
                { length: 17 },
                (_, i) => `${i + 1}.1`
            ),
            pkfo2Tables: Array.from(
                { length: 13 },
                (_, i) => `${i + 20}.1`
            )

        }
    },
    async mounted() {
        await this.loadApplyDataTable();
    },
    computed: {
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        },
        tableFields1_1() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'name_ru',
                    label: 'Наименование',
                    rowspan: 2
                },
                {
                    key: 'line_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];
        }
    },
    methods: {
        hasError(field, line_code) {
            return this.checkDataList.find(item =>
                item.agreed_form?.startsWith('note') && item.agreed_form !== 'note_12'
                && String(item.agreed_line_code) === String(line_code) &&
                item[field]
            );
        },
        async loadApplyDataTable(){
            if (this.pkfo1Tables.includes(this.table_number)) {
                await this.LoadDataTablePKFO1();
            } else if (this.pkfo2Tables.includes(this.table_number)) {
                await this.LoadDataTablePKFO2();
            }
        },
        backToPkfo() {
            this.$emit('back-to-pkfo');
        },
        async LoadDataTablePKFO1() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_uo_note_tables_pkfo1/` + this.year + '/' + this.region +  '/' + this.dataType + '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    const data = await response.json();
                    this.formApp = data.result;
                    this.notes = data.notes;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTablePKFO2() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_uo_note_tables_pkfo2/` + this.year + '/' + this.region +  '/' + this.dataType + '/' + this.version + '/' + this.table_number);
                if (response.status === 200) {
                    const data = await response.json();
                    this.formApp = data.result;
                    this.notes = data.notes;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы', error.toString());
            }
            this.loading = false;
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name, table_num: this.table_number, table_code: this.table_code };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_uo_note_tables/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileName = 'Пояснительная записка.xlsx';
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toNum(value, fix = 1) {
            if (typeof value === 'string') {
                if (value.trim() === '') {
                    return 0; // или можно вернуть null, если не хочешь показывать 0
                }
                const num = parseFloat(value.replace(',', '.'));
                return isNaN(num) ? 0 : parseFloat(num.toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }

    }
}
</script>

<style>
.bg-light-blue {
    background-color: #e8f4fa !important;
}
</style>

